export default __webpack_public_path__ + "static/media/Neddie-Screen-4.b71c969b.png";